// src/components/ShopsDataGrid.js

import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ShopsDataGrid = ({ shops, loading, reportType, moduleId, userLevel = 1 }) => {
  const navigate = useNavigate();

  const maskValue = (str) => {
    if (!str || typeof str !== 'string' || str === 'N/A') return 'N/A';
    if (str.length <= 4) return str;
    return str.slice(0, 4) + '#'.repeat(str.length - 4);
  };

  const columns = [
    { field: 'merchantId', headerName: 'Merchant ID', width: 160 },
    { field: 'sellerName', headerName: 'Merchant Name', width: 170 },
    { field: 'businessName', headerName: 'Shop Name', width: 180 },
    {
      field: 'mobileNumber',
      headerName: 'Mobile Number',
      width: 150,
      renderCell: (params) => {
        const val = params.value || 'N/A';
        return (userLevel > 1 && val !== 'N/A') ? maskValue(val) : val;
      },
    },
    {
      field: 'emailId',
      headerName: 'Email',
      width: 190,
      renderCell: (params) => {
        const val = params.value || 'N/A';
        return (userLevel > 1 && val !== 'N/A') ? maskValue(val) : val;
      },
    },
    { field: 'district', headerName: 'District', width: 140 },
    { field: 'city', headerName: 'CONSTITUENCY / City', width: 160 },
    { field: 'pincode', headerName: 'Pincode', width: 110 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 160,
      renderCell: (params) => {
        const buttonLabel = reportType === 'commission-reset' ? 'Reset Commission' : 'View Report';
        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => handleActionButtonClick(params.row)}
          >
            {buttonLabel}
          </Button>
        );
      },
    },
  ];

  const handleActionButtonClick = (shop) => {
    if (reportType === 'commission-reset') {
      handleResetCommission(shop);
    } else {
      handleViewReport(shop);
    }
  };

  const handleViewReport = (shop) => {
    navigate(`/shop-report/${reportType}/${shop.shopId}`, {
      state: { moduleId },
    });
  };

  const handleResetCommission = (shop) => {
    navigate(`/shop-report/reset/${reportType}/${shop.shopId}`, {
      state: { moduleId },
    });
  };

  const rows = shops.map((shop, index) => ({
    id: index,
    shopId: shop._id || shop.shopId,
    merchantId: shop.acemoneyUsercode || shop.sellerIdentifier || shop.merchantId || 'N/A',
    businessName: shop.businessName || 'N/A',
    sellerName: shop.sellerName || 'N/A',
    mobileNumber: shop.mobileNumber || 'N/A',
    emailId: shop.emailId || 'N/A',
    district: shop.district || 'N/A',
    city: shop.city || shop.village || 'N/A',
    pincode: shop.pincode || 'N/A',
  }));

  return (
    <div style={{ width: '100%', marginTop: 20 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        pageSize={25}
        rowsPerPageOptions={[25]}
        disableSelectionOnClick
        autoHeight
      />
    </div>
  );
};

export default ShopsDataGrid;
